import {
  buildAdminProfileForModal,
  buildArtistProfileForModal,
  firstNonEmpty,
} from './memberModalProfileUtils';

export const buildEventArtistProfilePayload = ({
  source,
  pickFirstString,
  normalizePartLabel,
  getMainPartBadgeLabel,
  normalizeEventUuidList,
}) => {
  if (!source) return null;
  const pick = typeof pickFirstString === 'function' ? pickFirstString : firstNonEmpty;
  const normalizePart =
    typeof normalizePartLabel === 'function' ? normalizePartLabel : (value) => String(value || '').trim();
  const normalizeEventUuids =
    typeof normalizeEventUuidList === 'function'
      ? normalizeEventUuidList
      : (value) => (Array.isArray(value) ? value : []);
  const partBadge =
    normalizePart(
      pick(
        source.partLabel,
        source.mainPartLabel,
        source.part,
        source.short,
        source.mainPart
      )
    ) ||
    normalizePart(
      typeof getMainPartBadgeLabel === 'function'
        ? getMainPartBadgeLabel(source.artist_parts || source.parts)
        : ''
    );
  const name = pick(source.artist_name, source.name);
  const nameEn = pick(source.name_en, source.artist_name_en);
  return buildArtistProfileForModal({
    artist: {
      ...source,
      id: source.artist_id || source.id || null,
      artist_id: source.artist_id || source.id || null,
      name,
      artist_name: name || source.artist_name || '',
      name_en: nameEn || source.name_en || '',
      artist_name_en: nameEn || source.artist_name_en || '',
      pic: source.artist_profile_picture || source.profile_picture || source.pic || '',
      artist_profile_picture:
        source.artist_profile_picture || source.profile_picture || source.pic || '',
      partLabel: partBadge,
      mainPartLabel: partBadge,
      part: partBadge,
      mainPart: partBadge,
      custom_roles: Array.isArray(source.custom_roles)
        ? source.custom_roles
        : Array.isArray(source.customRoles)
          ? source.customRoles
          : [],
      instagram_url: pick(source.instagram_url, source.instagram),
      twitter_url: pick(source.twitter_url, source.twitter),
      facebook_url: pick(source.facebook_url, source.facebook),
      hp_url: pick(source.hp_url, source.homepage_url, source.hp),
      career_timeline: Array.isArray(source.career_timeline)
        ? source.career_timeline
        : (Array.isArray(source.careerTimeline) ? source.careerTimeline : []),
      profile_one_liner: pick(
        source.profile_one_liner,
        source.one_liner,
        source.comment,
        source.bio,
        source.notes
      ),
      eventMembershipLabel: pick(source.eventMembershipLabel, source.event_membership_label),
      eventPartLabel: pick(source.eventPartLabel, source.event_part_label),
      eventUuids: normalizeEventUuids(source.eventUuids || source.event_uuids),
      eventPartAssignments: Array.isArray(source.eventPartAssignments)
        ? source.eventPartAssignments
        : Array.isArray(source.event_part_assignments)
          ? source.event_part_assignments
          : [],
      groupEvents: Array.isArray(source.groupEvents)
        ? source.groupEvents
        : Array.isArray(source.group_events)
          ? source.group_events
          : [],
      isUnifiedEventGroupChat:
        source.isUnifiedEventGroupChat === true || source.is_unified_event_group_chat === true,
    },
  });
};

export const buildEventAdminProfilePayload = ({
  source,
  pickFirstString,
}) => {
  if (!source) return null;
  const pick = typeof pickFirstString === 'function' ? pickFirstString : firstNonEmpty;
  const name = pick(
    source.display_name,
    source.full_name,
    source.admin_full_name,
    source.nickname,
    source.username
  ) || '未設定';
  return buildAdminProfileForModal({
    admin: {
      ...source,
      display_name: name,
      full_name: name,
      nickname: pick(source.nickname, source.display_name_sub),
      position: source.position || '',
      department: source.department || '',
      profile_one_liner: pick(source.profile_one_liner, source.comment, source.note),
      profile_picture: source.profile_picture || source.admin_profile_picture || '',
      eventMembershipLabel: pick(source.eventMembershipLabel, source.event_membership_label),
    },
  });
};

export const createEventProfilePayloadBuilders = ({
  pickFirstString,
  normalizePartLabel,
  getMainPartBadgeLabel,
  normalizeEventUuidList,
}) => ({
  buildArtistProfilePayload: (source) =>
    buildEventArtistProfilePayload({
      source,
      pickFirstString,
      normalizePartLabel,
      getMainPartBadgeLabel,
      normalizeEventUuidList,
    }),
  buildAdminProfilePayload: (source) =>
    buildEventAdminProfilePayload({
      source,
      pickFirstString,
    }),
});
